import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { GeneralRoutePaths } from '../../../core/enums/route-types.enum';
import { SonataSessionService } from '../../../core/services/sonata-session/sonata-session.service';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-external-redirect',
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './external-redirect.component.html',
})
export class ExternalRedirectComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private sonataSessionService = inject(SonataSessionService);

  ngOnInit(): void {
    const routeData = this.activatedRoute.routeConfig.data || this.activatedRoute.snapshot.routeConfig.data;
    if (routeData?.target) {
      if (routeData.target === environment.backOfficeURL) {
        this.sonataSessionService.open();
      } else {
        window.location.href = routeData.target;
      }
    } else if (this.router.url !== `/${GeneralRoutePaths.NEWS}`) {
      this.router.navigate([GeneralRoutePaths.NEWS]);
    }
  }
}
